//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GChart } from 'vue-google-charts'
import axios from 'axios'

export default {
  components: {
    GChart
  },
  // ต้องมี props เสมอ
  props: {
    title: String,
    loc: String,
    date: String
  },
  data () {
    return {
      chartData: [],
      tab: 'prequest',
      grpstatus: {},
      arequest: [],
      arepairs: [],
      nrequest: 0,
      nrepairs: 0,
      thumbStyle: {
        right: '0px',
        borderRadius: '4px',
        backgroundColor: '#9933ff',
        width: '4px',
        opacity: 0.75
      },

      barStyle: {
        right: '0px',
        borderRadius: '4px',
        backgroundColor: '#e0e0e0',
        width: '4px',
        opacity: 0.2
      },

      chartOptions: {
        backgroundColor: {
          fill: '#ffffff',
          fillOpacity: 0.5
        },
        title: null,
        fontSize: 12,
        fontName: 'Tahoma',
        legend: {
          position: 'none'
        },
        colors: ['red', 'green'],
        bar: {
          groupWidth: '80%'
        },
        vAxis: {
          minValue: 0,
          maxValue: 10,
          gridlines: {
            count: 0
          }
          //   minorGridlines: {
          //     count: 0,
          //   },
        },
        animation: {
          duration: 1200,
          easing: 'out',
          startup: true
        },
        annotations: {
          textStyle: {
            fontName: 'Times-Roman',
            fontSize: 18,
            bold: true,
            italic: true,
            color: '#871b47'
          }
        }
      }
    }
  },
  watch: {
    tab: function (newValue, oldValue) {
      this.LoadDataChart()
      this.LoadData()
    }
  },
  created () {
    this.pullData()
  },
  async mounted () {
    this.LoadData()
    this.LoadDataChart()
  },
  methods: {
    // LoadFirst() {
    //   this.pulling = setTimeout(() => {
    //     this.LoadData()
    //   }, 1000)
    // },
    pullData () {
      this.pulling = setInterval(() => {
        var currentdate = new Date()
        if (
          currentdate.getMinutes() % 5 === 0 &&
          currentdate.getSeconds() === 0
        ) {
          this.LoadData()
          this.LoadDataChart()
          // REFRESH FOR 5 MIN
          // console.log(currentdate)
        }
      }, 1000)
    },
    LoadData () {
      try {
        this.$q.loading.show()
        const postjson = {
          authen: { keycode: this.$keycode },
          filter: {
            loc: this.loc,
            process: this.title
          }
        }
        axios({
          method: 'post',
          url: `${this.$apiflask}/nygctroom/board6_Andon`,
          data: postjson
        }).then((res) => {
          // console.log(res.data)
          this.arequest = res.data.request
          this.arepairs = res.data.repair
          this.nrequest = res.data.request_count
          this.nrepairs = res.data.repair_count
          this.$q.loading.hide()
        })
      } catch (err) {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: err,
          html: true
        })
        this.$q.loading.hide()
      }
    },

    LoadDataChart () {
      try {
        this.$q.loading.show()
        const postjson = {
          authen: { keycode: this.$keycode },
          filter: {
            loc: this.loc,
            date: this.date,
            process: this.title
          }
        }
        axios({
          method: 'post',
          url: `${this.$apiflask}/nygctroom/board6_ChartAndon`,
          data: postjson
        }).then((res) => {
          // console.log(res.data)
          this.chartData = res.data.chartData
          this.$q.loading.hide()
        })
      } catch (err) {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: err,
          html: true
        })
        this.$q.loading.hide()
      }
    },

    getcolorrequest (r) {
      let _min = parseInt(r.STATUS_MIN)
      if (_min < 2) {
        return 'bg-green-6 text-white'
      } else if (_min > 3) {
        return 'bg-red-6 text-white'
      } else {
        return 'bg-yellow-6 text-black'
      }
    },
    getcolorrepair (r) {
      let _min = parseInt(r.STATUS_MIN)
      if (_min < 5) {
        return 'bg-green-6 text-white'
      } else if (_min > 10) {
        return 'bg-red-6 text-white'
      } else {
        return 'bg-yellow-6 text-black'
      }
    }
  }
}
